import { Button } from '@modusign/design-system';
import cx from 'classnames';
import { ChangeEvent, useState } from 'react';
import { useDispatch } from 'react-redux';

import useUpdateBulkRequestTitle from '@app/features/bulkRequest/hooks/useUpdateBulkRequestTitle';
import { useWorkspaceId } from '@app/hooks/useWorkspaceId';
import { modalClose } from '@app/store/modal/actions';

interface BulkRequestUpdateTitleModalProps {
  bulkRequestId: string;
  title: string;
}

function BulkRequestUpdateTitleModal({
  bulkRequestId,
  title: initialTitle,
}: BulkRequestUpdateTitleModalProps) {
  const dispatch = useDispatch();
  const [title, setTitle] = useState(initialTitle);
  const [errorMessage, setErrorMessage] = useState('');

  const workspaceId = useWorkspaceId();
  const { mutateAsync: updateBulkRequestTitle, isLoading } =
    useUpdateBulkRequestTitle(bulkRequestId);

  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    const { value } = event.target;
    let error = '';

    if (!value) {
      error = '템플릿 이름 입력은 필수입니다.';
    } else if (value.length < 2) {
      error = '최소 2자 이상 입력해 주세요.';
    }
    setErrorMessage(error);
    setTitle(value);
  }

  return (
    <div className="Container Container--max-xxs">
      <div className="Card Card--pop box-8x align-center">
        <h3 className="space-4x">
          <strong>대량전송 이름 변경</strong>
        </h3>
        <div className="space-6x">
          <p className="space-4x">
            변경할 대량전송 이름을 입력하고
            <br />
            변경하기 버튼을 눌러주세요.
          </p>
          <div className={cx('InputSet', { 'InputSet--invalid': !!errorMessage })}>
            <input
              className="InputSet__text-input InputSet__dividing-input--quarter"
              maxLength={100}
              name="title"
              placeholder="대량전송 이름을 2자 이상 입력해 주세요."
              type="text"
              value={title}
              onChange={handleChange}
            />
            {errorMessage && <p className="InputSet__invalidity-message">{errorMessage}</p>}
          </div>
        </div>
        <button
          className="Btn"
          type="button"
          onClick={() => {
            dispatch(modalClose());
          }}
        >
          취소
        </button>
        <Button
          disabled={!!errorMessage || initialTitle === title}
          isLoading={isLoading}
          variant="primary"
          onClick={() => {
            if (!errorMessage && initialTitle !== title) {
              updateBulkRequestTitle([workspaceId, bulkRequestId, { title }], {
                onSuccess: () => {
                  dispatch(modalClose());
                },
              });
            }
          }}
        >
          변경하기
        </Button>
      </div>
    </div>
  );
}

export default BulkRequestUpdateTitleModal;
